<!-- <section class="nsw-section"> -->

    <!-- <div class="frame-2220">
        <div class="rowcount-text">
            Showing {{pageSize}} results per page
        </div>
    </div> -->
    <h5>Showing {{pageSize}} results per page</h5>
    <div class="nsw-table nsw-table--striped nsw-table--bordered table-container"  [tabindex]="0">       
        <table>                    
            <thead>
                <tr>
                    <th width="30%" *ngFor="let column of columnsToDisplay; let i = index">                                
                        {{getColumnLabel(column?.name!)}}                                                              
                    </th>                            
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of displayRows; let rowIndex = index">
                    <td *ngFor="let column of columnsToDisplay; let colIndex = index">                               
                        {{getData(row, column?.name!)}}                                                           
                    </td>                           
                </tr>                        
            </tbody>
        </table>        
    </div>
    
    <nav class="nsw-pagination" aria-label="Pagination" style="margin-bottom:32px;">
        <ul>
            <li                
                (click)="onPageLinkClicked($event, 1)">
                
                <button class="nsw-icon-button" href="#" [attr.aria-disabled]="1 >= currentPageNumber"                   
                    [class.disabled]="1 >= currentPageNumber"
                    [class.disabled-link]="1 >= currentPageNumber"                    
                    [attr.disabled]="1 >= currentPageNumber ? '' : null">
                    <span class="material-icons nsw-material-icons" focusable="false"
                        aria-hidden="true">keyboard_arrow_left</span>                   
                    <span class="sr-only">First</span>
                </button>
            </li>
            <li                
                (click)="onPageLinkClicked($event, currentPageNumber - 1)">
                
                <button class="nsw-icon-button" href="#" [attr.aria-disabled]="1 >= currentPageNumber"                   
                    [class.disabled]="1 >= currentPageNumber"
                    [class.disabled-link]="1 >= currentPageNumber"                    
                    [attr.disabled]="1 >= currentPageNumber ? '' : null" 
                    >
                    <span class="material-icons nsw-material-icons" focusable="false"
                        aria-hidden="true">keyboard_arrow_left</span>
                    <span class="sr-only">Previous</span>
                </button>
            </li>
            <li *appCounter="let page of pageCount" (click)="onPageLinkClicked($event, page)">
                <a [class.active]="page === currentPageNumber" href="#">
                    <span class="sr-only">Page </span>{{page}}</a>
            </li>          

            <li (click)="onPageLinkClicked($event, currentPageNumber + 1)">
                <button class="nsw-icon-button"                     
                    [attr.aria-disabled]="pageCount === currentPageNumber"                   
                    [class.disabled]="pageCount === currentPageNumber"
                    [attr.disabled]="pageCount === currentPageNumber ? '' : null" 
                    [class.disabled-link]="pageCount === currentPageNumber">
                    <span class="material-icons nsw-material-icons" focusable="false"
                        aria-hidden="true">keyboard_arrow_right</span>
                    <span class="sr-only">Next</span>
                </button>
            </li>

            <li (click)="onPageLinkClicked($event, pageCount)">
                <button class="nsw-icon-button"                     
                    [attr.aria-disabled]="pageCount === currentPageNumber"                   
                    [class.disabled]="pageCount === currentPageNumber"
                    [attr.disabled]="pageCount === currentPageNumber ? '' : null" 
                    [class.disabled-link]="pageCount === currentPageNumber">
                    <span class="material-icons nsw-material-icons" focusable="false"
                        aria-hidden="true">keyboard_arrow_right</span>                   
                    <span class="sr-only">Last</span>
                </button>
            </li>

        </ul>
    </nav>


<!-- </section> -->